import { render, staticRenderFns } from "./TestingPage.vue?vue&type=template&id=828f1ea6&scoped=true&"
import script from "./TestingPage.vue?vue&type=script&lang=js&"
export * from "./TestingPage.vue?vue&type=script&lang=js&"
import style0 from "./TestingPage.vue?vue&type=style&index=0&id=828f1ea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f1ea6",
  null
  
)

export default component.exports